import React, { Component } from 'react';

import HeaderMap from './HeaderMap';

export default class SupplierHeaderMap extends Component {
    constructor(props) {
        super(props);

        this.getCenterBoundaries = this.getCenterBoundaries.bind(this);
    }

    getCenterBoundaries() {
        return {
            left: wo$('#location-header')[0].getBoundingClientRect().right,
            right: wo$('#header-logo-section')[0].getBoundingClientRect().left
        };
    }

    render() {
        return (
            <React.StrictMode>
                <HeaderMap
                    address={this.props.address}
                    countryCode={this.props.countryCode}
                    backgroundMapUrl={this.props.backgroundMapUrl}
                    getCenterBoundaries={this.getCenterBoundaries}
                    ignoreAddressChange={this.props.ignoreAddressChange}
                    mapContainerId="header-map"
                    apiKey={this.props.apiKey}
                    styleId={this.props.styleId}
                    useStaticMap={this.props.useStaticMap}
                />
            </React.StrictMode>
        );
    }
}
